<template>
	<div class="section4">
		<div class="cm-tabs-line">
			<span class="cm-tab" :class="{ 'cm-tab2': status == 0 }" @click="tabChange(0)">{{ $t('进行中') }}</span>
			<span class="cm-tab" :class="{ 'cm-tab2': status == 1 }" @click="tabChange(1)">{{ $t('已结束') }}</span>
		</div>
		<div class="order-list">
			<div class="list-wrap">
				<div class="list-item" v-for="v in list" :key="v.id">
					<div class="top-con">
						<div class="left">
							<img v-for="value in v.product_list" :key="value.id" :src="value.image" class="coin1">
							<span class="field">{{ v.invest }}</span>
							<span class="status" style="color: rgb(0, 240, 255);">
								{{ status == 0 ? $t('进行中') : $t('已结束') }}
							</span>
						</div>
						<div class="right">
							<!-- <div class="return-detail">{{ $t('收益详情') }}</div> -->
						</div>
					</div>
					<div class="row-item">
						<div class="column">
							<span class="label">{{ $t('机器人ID') }}</span>
							<span>{{ v.id }}</span>
						</div>
						<div class="column">
							<span class="label">{{ $t('投入金额') }}</span>
							<span>{{ v.amount }}USD</span>
						</div>
						<div class="column">
							<span class="label">{{ $t('投资') }}</span>
							<span class="rate win">{{ v.order_rate }}%</span>
						</div>
						<div class="column">
							<span class="label wincount">{{ $t('套利次数') }}</span>
							<span>{{ v.time }}</span>
						</div>
						<div class="column last">
							<span class="label">{{ $t('委托时间') }}</span>
							<span>{{ v.startdate }}</span>
						</div>
					</div>
					<div class="row-item">
						<div class="column">
							<span class="label">{{ $t('运行时长') }}</span>
							<span>{{ v.day }}h</span>
						</div>
						<div class="column">
							<span class="label">{{ $t('总收益') }}</span>
							<span>{{ v.totalincome }}</span>
						</div>
						<div class="column">
							<span class="label">{{ $t('网格数量') }}</span>
							<span>{{ v.number }}</span>
						</div>
						<div class="column">
							<span class="label">{{ $t('服务费') }}</span>
							<span>{{ v.commission }}USDT</span>
						</div>
						<div class="column last">
							<span class="label">{{ $t('结束时间') }}</span>
							<span>{{ v.expire }}</span>
						</div>
					</div>
				</div>
				<div class="dasda" v-if="list.length <= 0">{{ $t('没有更多数据了') }}</div>
			</div>
		</div>

		<oPage v-if="page.total > page.limit" :current-page.sync="page.page" :page-size.sync="page.limit"
			:total="page.total" @current-change="getdata" />
	</div>
</template>

<script>

import { get } from '@/http/request'
import apis from '@/http/api'
import oPage from '@/common/pc/oPage.vue'
export default {
	components: {
		oPage,
	},
	props: {
	},
	data() {
		return {
			status: 0, // 0=工作中1=已结束
			list: [],
			page: {
				page: 1,
				limit: 10,
				total: 10,
			},
		};
	},
	watch: {
	},
	created() {
		this.init()
	},
	methods: {

		init() {
			this.page.page = 1
			this.getdata(false)
		},
		getdata(showLoading = true) {
			get(apis.getUserOrderList, {
				showLoading,
				...this.page,
				status: this.status,
			}).then(res => {
				if (res.code != 1) return
				this.list = res.data.list || res.data
				this.page.total = res.data.total || 0
			})
		},
		tabChange(val) {
			this.status = val
			this.init()
		}
	},
}; 
</script>
<style lang="scss" scoped>
.section4 {
	min-height: 524px;
	border-radius: 12px;
	border: 2Px solid #252731;
	background: #12141e;
	margin-top: 30px;
	margin-bottom: 50px;

	.order-list {
		padding: 0 20px;

		.list-wrap {
			// height: 450px;
			border-top: 1px solid #252731;
			overflow-y: auto;
			padding: 20px;

			.list-item {
				border-bottom: 1px solid #31323f;
				padding: 10px 0;

				.row-item {
					min-height: 30px;
					display: flex;
					align-items: center;

					.column {
						flex: 1;
						display: flex;
						align-items: center;
						flex-direction: row;
						font-size: 14px;

						.label {
							width: 70px;
							color: #5e5e7a;
							margin-bottom: 0;

							&:nth-child(2) {
								font-size: 13px;
							}
						}
					}

					.win {
						color: #00f0ff;
						padding: 0 5px;
					}
				}

				.top-con {
					height: 30px;
					align-items: center;
					display: flex;
					justify-content: space-between;
					margin-bottom: 10px;

					.right {
						display: flex;

						.return-detail {
							min-width: 88px;
							padding: 6px 12px;
							border-radius: 99px;
							background: #1a1b24;
							color: #fff;
							cursor: pointer;
						}
					}

					.left {
						display: flex;
						align-items: center;

						.status {
							margin-left: 10px;
							padding: 3px 12px;
							border-radius: 27px;
							background: #000;
						}

						.field {
							margin-left: 10px;
						}

						img {
							width: 30px;
							height: 30px;
							margin-left: -10px;
							border-radius: 50%;

							&:first-child {
								margin-left: 0;
							}
						}
					}
				}
			}
		}

		.dasda {
			text-align: center;
			margin: 50px auto;
			color: #888;
		}
	}

	.cm-tabs-line {
		width: 250px;
		margin-left: 20px;
		position: relative;
		border-bottom: 1px solid #12141e;
		display: flex;
		flex-wrap: nowrap;
		flex-direction: row;
		align-items: center;
		justify-content: center;

		.cm-tab {
			height: 45px;
			display: flex;
			flex-wrap: nowrap;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			line-height: 1 !important;
			font-size: 15px;
			cursor: pointer;
			color: #888;
			flex: 1;
			text-align: center;

			&.cm-tab2 {
				color: #fff;
				border-bottom: 1px solid #fff;
			}
		}
	}
}
</style>